var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    "data-bbox": "30 54 140 92",
    viewBox: "30 54 140 92",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-k4bywml4 svg [data-color=\"1\"] {fill: #000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 54v92h140V54H30zm136.6 29.3H63.1V57.4h103.5v25.9zM33.4 113.1V86.7h133.2v26.4H33.4zm26.3-55.7v25.9H33.4V57.4h26.3zm-26.3 59.1h102.1v26.1H33.4v-26.1zm105.5 26.1v-26.1h27.7v26.1h-27.7z",
    fill: "#000000",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallIcon);
export default __webpack_public_path__ + "static/media/wall-icon.b7f6c8276a462ab7eded17f143baac1a.svg";
export { ForwardRef as ReactComponent };